import React, {useEffect, useState} from "react";
import {Button, IconButton, Popover, TextareaAutosize, Tooltip, Typography} from "@mui/material";
import {Apps, KeyboardBackspace} from "@mui/icons-material";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import DocumentTypeTableApplet from "../eoec/applet/impl/IntegrationTemplate/DocumentTypeTableApplet";
import DocumentTypeFormTableApplet from "../eoec/applet/impl/IntegrationTemplate/DocumentTypeFormTableApplet";
import ReactJson from "react-json-view";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../util/Buffer";
import DeveloperMenu from "../components/Navigation/DeveloperMenu";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function DashboardIntegrationTemplate() {
    const [documentTypeEnterpriseObject] = useState(() => enterpriseObjectClassFactory("DocumentType") as EnterpriseObject);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const [showContent, setShowContent] = React.useState<boolean>(true);
    const [documentTypeFormBuffer, setDocumentTypeFormBuffer] = React.useState<Map<string, any>>();

    const navigate = useNavigate();

    useEffect(() => {
        const enterpriseComponentRecordChangedListener = (ec: EnterpriseComponent) => {
            let b: Map<string, any>[] = prepareBuffer(ec)

            for (let i = 0; i < b.length; i++) {
                if (b[i].get("RowSelected") === true) {
                    setDocumentTypeFormBuffer(b[i])
                }
            }
        }
        const enterpriseComponentLoadCompletedListener = (ec: EnterpriseComponent) => {
            let b: Map<string, any>[] = prepareBuffer(ec)

            for (let i = 0; i < b.length; i++) {
                if (b[i].get("RowSelected") === true) {
                    setDocumentTypeFormBuffer(b[i])
                }
            }
        }

        const documentTypeFormEnterpriseComponent: EnterpriseComponent = documentTypeEnterpriseObject.getEnterpriseComponent("DocumentTypeForm2")!;

        documentTypeFormEnterpriseComponent.addRecordChangedListener(enterpriseComponentRecordChangedListener);
        documentTypeFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        return () => {
            documentTypeFormEnterpriseComponent.removeRecordChangedListener(enterpriseComponentRecordChangedListener);
            documentTypeFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        }
    }, []);

    function getFormInputTemplateAsJSON() {
        if (documentTypeFormBuffer === undefined) {
            return {}
        }
        if (documentTypeFormBuffer.get("FormInputTemplate") === null) {
            return {}
        }

        return documentTypeFormBuffer.get("FormInputTemplate")
    }

    function getFormInputTemplateAsText() {
        if (documentTypeFormBuffer === undefined) {
            return {}
        }
        if (documentTypeFormBuffer.get("FormInputTemplateString") === null) {
            return {}
        }

        return documentTypeFormBuffer.get("FormInputTemplateString")
    }

    function renderContent() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "50px", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "9px", marginLeft: "20px", width: "300px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "-2px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                navigate("/dashboard");
                            }}>
                            <KeyboardBackspace sx={{color: "#1498D8", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Integration Templates</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", paddingRight: "60px"}}>
                    <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                        <DocumentTypeTableApplet enterpriseComponent={documentTypeEnterpriseObject.getEnterpriseComponent("DocumentType")} />
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", paddingRight: "60px"}}>
                    <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                        <DocumentTypeFormTableApplet enterpriseComponent={documentTypeEnterpriseObject.getEnterpriseComponent("DocumentTypeForm2")} />
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", paddingRight: "60px"}}>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <div style={{margin: "0 0 0 30px"}}>
                            <Typography style={{fontSize: 22, fontWeight: 500, color: "#1498D8"}}>Integration Template</Typography>
                        </div>
                        <div style={{margin: "0 0 0 30px"}}>
                            <Button className={css_buttons.blueOutlinedButton} style={{height: "30px"}} onClick={() => {
                                setShowContent(true);
                            }}>JSON
                            </Button>
                        </div>
                        <div style={{margin: "0 0 0 10px"}}>
                            <Button className={css_buttons.blueOutlinedButton} style={{height: "30px"}} onClick={() => {
                                setShowContent(false);
                            }}>Text
                            </Button>
                        </div>

                    </div>
                    {showContent ? (
                        <div style={{border: "1px solid #EFEFEF", borderRadius: "10px", marginLeft: "30px", marginTop: "5px", marginRight: "50px", marginBottom: "50px", paddingLeft: "30px", paddingTop: "10px", paddingBottom: "10px", width: "calc(100% - 30px)"}}>
                            <ReactJson src={getFormInputTemplateAsJSON()} collapseStringsAfterLength={575} collapsed={false}/>
                        </div>
                    ) : (
                        <div style={{border: "1px solid #EFEFEF", borderRadius: "10px", marginLeft: "30px", marginTop: "5px", marginBottom: "50px", paddingLeft: "10px", paddingTop: "10px", paddingBottom: "10px", width: "calc(100% - 10px)"}}>
                            <TextareaAutosize style={{fontSize: 14, fontFamily: "courier", fontWeight: 400, color: "#000000", width: "99%"}} defaultValue={getFormInputTemplateAsText()}></TextareaAutosize>
                        </div>
                    )}
                </div>
            </>
        );
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Dashboard</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <DeveloperMenu/>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderContent()}
        </div>
    );
}